import { render, staticRenderFns } from "./team-list.vue?vue&type=template&id=47e3f623"
import script from "./team-list.vue?vue&type=script&lang=js"
export * from "./team-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports